(() => {
  const locale = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  if (locale !== 'en') return;

  const translations = new Map([
    ['Nom', 'Name'],
    ['Nom complet', 'Full name'],
    ['Prénom', 'First name'],
    ['E-mail', 'Email'],
    ['Email', 'Email'],
    ['Téléphone', 'Phone'],
    ['Numéro de téléphone', 'Phone number'],
    ['Date', 'Date'],
    ['Date souhaitée', 'Preferred date'],
    ['Date de l’événement', 'Event date'],
    ["Date de l'événement", 'Event date'],
    ['Date de livraison', 'Delivery date'],
    ['Commune de livraison', 'Delivery town'],
    ['Ville de livraison', 'Delivery town'],
    ['Adresse de livraison', 'Delivery address'],
    ['Code postal', 'Postcode'],
    ['Occasion', 'Occasion'],
    ['Type de projet', 'Project type'],
    ['Budget', 'Budget'],
    ['Votre budget', 'Your budget'],
    ['Votre projet', 'Your project'],
    ['Décrivez votre projet', 'Tell us about your project'],
    ['Message', 'Message'],
    ['Votre message', 'Your message'],
    ['Moodboard', 'Moodboard'],
    ['Pièce jointe', 'Attachment'],
    ['Pièces jointes', 'Attachments'],
    ['Ajouter un fichier', 'Upload a file'],
    ['Ajouter des fichiers', 'Upload files'],
    ['Téléverser un fichier', 'Upload a file'],
    ['Téléverser des fichiers', 'Upload files'],
    ['Choisir un fichier', 'Choose a file'],
    ['Choisir des fichiers', 'Choose files'],
    ['Parcourir', 'Browse'],
    ['Envoyer', 'Send'],
    ['Soumettre', 'Submit'],
    ['Envoyer ma demande', 'Send my request'],
    ['Obligatoire', 'Required'],
    ['Requis', 'Required'],
    ['Optionnel', 'Optional'],
    ['Facultatif', 'Optional'],
    ['facultatif', 'optional'],
    ['Autre', 'Other'],
    ['Oui', 'Yes'],
    ['Non', 'No'],
    ['Choisir', 'Choose'],
    ['Sélectionner', 'Select'],
    ['Merci !', 'Thank you!'],
    ['Merci', 'Thank you'],
    ['Votre demande a bien été envoyée.', 'Your request has been sent.'],
    ['Votre demande a bien été transmise.', 'Your request has been sent.'],
    ['Fichier trop volumineux', 'File is too large'],
    ['Ce champ est obligatoire', 'This field is required'],
    ['Veuillez remplir ce champ', 'Please fill in this field']
  ]);

  const phraseTranslations = [
    ['Votre nom', 'Your name'],
    ['Votre e-mail', 'Your email'],
    ['Votre email', 'Your email'],
    ['Votre téléphone', 'Your phone number'],
    ['Numéro de téléphone', 'Phone number'],
    ['Choisissez une option', 'Choose an option'],
    ['Sélectionnez une option', 'Select an option'],
    ['Décrivez votre demande', 'Tell us about your request'],
    ['Décrivez votre projet', 'Tell us about your project'],
    ['Ajoutez votre moodboard', 'Upload your moodboard'],
    ['Ajoutez un moodboard', 'Upload a moodboard'],
    ['Glissez-déposez', 'Drag and drop'],
    ['ou cliquez pour parcourir', 'or click to browse'],
    ['Cliquez pour parcourir', 'Click to browse'],
    ['Formats acceptés', 'Accepted formats'],
    ['Taille maximale', 'Maximum size']
  ];

  const observed = new WeakSet();

  function mapped(value) {
    if (!value) return value;
    const leading = value.match(/^\s*/)?.[0] || '';
    const trailing = value.match(/\s*$/)?.[0] || '';
    const trimmed = value.trim();
    const star = /\s*\*$/.test(trimmed);
    const core = trimmed.replace(/\s*\*$/, '').trim();
    let translated = translations.get(core);
    if (!translated) {
      translated = core;
      for (const [from, to] of phraseTranslations) {
        if (translated.includes(from)) translated = translated.split(from).join(to);
      }
      if (translated === core) return value;
    }
    return leading + translated + (star ? ' *' : '') + trailing;
  }

  function insideFormLift(node) {
    let el = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    while (el) {
      if (el.matches?.('.fv__app, .flowever-formlift-frame')) return true;
      const root = el.getRootNode?.();
      if (root instanceof ShadowRoot) el = root.host;
      else el = el.parentElement;
    }
    return false;
  }

  function translateElement(el) {
    if (!(el instanceof Element)) return;
    if (!insideFormLift(el)) return;

    ['placeholder', 'aria-label', 'title'].forEach((attr) => {
      const value = el.getAttribute(attr);
      const next = mapped(value);
      if (value && next !== value) el.setAttribute(attr, next);
    });

    if (el.tagName === 'OPTION') {
      const next = mapped(el.textContent);
      if (next !== el.textContent) el.textContent = next;
    }

    if (el.tagName === 'INPUT' && ['submit', 'button'].includes((el.type || '').toLowerCase())) {
      const next = mapped(el.value);
      if (next !== el.value) el.value = next;
    }

    if (el.shadowRoot) {
      translateRoot(el.shadowRoot);
      observeRoot(el.shadowRoot);
    }

    if (el.tagName === 'IFRAME') translateFrame(el);
  }

  function translateText(node) {
    if (!insideFormLift(node)) return;
    const next = mapped(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function translateRoot(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      translateText(root);
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE) translateElement(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) translateText(node);
      else translateElement(node);
    }
  }

  function translateFrame(frame) {
    const run = () => {
      try {
        const doc = frame.contentDocument;
        if (!doc?.body) return;
        doc.body.classList.add('flowever-formlift-frame');
        translateRoot(doc.body);
        observeRoot(doc.body);
      } catch (_) {
        // Cross-origin FormLift frames cannot be modified from the theme.
      }
    };
    frame.addEventListener('load', run);
    run();
  }

  function observeRoot(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => translateRoot(node));
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll('.fv__app').forEach((container) => {
      translateRoot(container);
      observeRoot(container);
      container.querySelectorAll('iframe').forEach(translateFrame);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();

  observeRoot(document.body);
  let attempts = 0;
  const retry = window.setInterval(() => {
    scan();
    attempts += 1;
    if (attempts >= 20) window.clearInterval(retry);
  }, 500);
})();
